import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { FlashMessagesService } from '../../../shared/flash-messages/service/flash.messages.service';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { AdjustmentType } from '../../models/adjustment-type';
import { tap } from 'rxjs/operators';
import { AdjustmentTypeHttpService } from './adjustment-type.http-service';
import { TranslateService } from '@ngx-translate/core';
import { AdjustmentSign } from '../../models/adjustment-sign.enum';
import { AdjustmentTypeStoreInterface } from './adjustment-type.store.interface';

@Injectable()
export class AdjustmentTypeStore implements AdjustmentTypeStoreInterface {

  private creditAdjustmentTypes: ReplaySubject<AdjustmentType[]> = new ReplaySubject<AdjustmentType[]>(1);
  private debitAdjustmentTypes: ReplaySubject<AdjustmentType[]> = new ReplaySubject<AdjustmentType[]>(1);

  constructor(
    private adjustmentTypeHttpService: AdjustmentTypeHttpService,
    private flashMessagesService: FlashMessagesService,
    private translateService: TranslateService
  ) { }

  loadCreditAdjustmentTypes(): Observable<AdjustmentType[]> {
    return this.loadAdjustmentTypes(AdjustmentSign.CREDIT);
  }

  loadDebitAdjustmentTypes(): Observable<AdjustmentType[]> {
    return this.loadAdjustmentTypes(AdjustmentSign.DEBIT);
  }

  getCreditAdjustmentTypes(): Observable<AdjustmentType[]> {
    return this.creditAdjustmentTypes.asObservable();
  }

  getDebitAdjustmentTypes(): Observable<AdjustmentType[]> {
    return this.debitAdjustmentTypes.asObservable();
  }

  getAdjustmentType(id: number, adjustmentSign: AdjustmentSign): Observable<AdjustmentType> {
    const adjustmentTypesSubject = AdjustmentSign.CREDIT === adjustmentSign ? this.creditAdjustmentTypes : this.debitAdjustmentTypes;
    return adjustmentTypesSubject.map(adjustmentTypes => adjustmentTypes.find(adjustmentType => adjustmentType.id === id));
  }

  private loadAdjustmentTypes(adjustmentSign: AdjustmentSign): Observable<AdjustmentType[]> {
    return (AdjustmentSign.CREDIT === adjustmentSign
      ? this.adjustmentTypeHttpService.getCreditAdjustmentTypes()
      : this.adjustmentTypeHttpService.getDebitAdjustmentTypes())
      .catch(error => {
        this.flashMessagesService.error(this.translateService.instant('MESSAGES.ERROR.COULD_NOT_GET_ADJUSTMENTS'));
        return Observable.throw(error);
      })
      .pipe(
        tap((result: AdjustmentType[]) => {
          AdjustmentSign.CREDIT === adjustmentSign ? this.creditAdjustmentTypes.next(result) : this.debitAdjustmentTypes.next(result);
        })
      );
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/adjustment-type/adjustment-type.store.ts